/* eslint-disable import/no-cycle */
import {
  primaryColors,
  transparentColors
} from '@assets/styles/helpers/colors.styles'
import { TileProps } from './Tile'

export const getTileStyles = (
  color: TileProps['color'],
  customColor?: boolean
) => {
  if (customColor) {
    return {
      boxShadow: 'none',
      background: 'var(--background)',
      borderRadius: '1rem',
      padding: '2rem',
      width: '100%',
      height: '100%',
      position: 'relative',
      minWidth: 0,
      overflow: 'hidden'
    }
  }
  switch (color) {
    case 'black':
      return {
        boxShadow: 'none',
        background: transparentColors.blackShade3,
        borderRadius: '1rem',
        padding: '2rem',
        width: '100%',
        height: '100%',
        position: 'relative',
        minWidth: 0,
        overflow: 'hidden'
      }
    case 'white':
      return {
        boxShadow: 'none',
        background: transparentColors.whiteShade3,
        borderRadius: '1rem',
        padding: '2rem',
        width: '100%',
        height: '100%',
        position: 'relative',
        minWidth: 0,
        overflow: 'hidden'
      }
    case 'orange':
      return {
        boxShadow: 'none',
        background: transparentColors.orangeShade3,
        borderRadius: '1rem',
        padding: '2rem',
        width: '100%',
        height: '100%',
        position: 'relative',
        minWidth: 0,
        overflow: 'hidden'
      }
    case 'gradient':
      return {
        boxShadow: 'none',
        background: `linear-gradient(180deg, ${primaryColors.black} 40%, ${primaryColors.orange} 100%)`,
        borderRadius: '1rem',
        padding: '2rem',
        width: '100%',
        height: '100%',
        position: 'relative',
        minWidth: 0,
        overflow: 'hidden'
      }
    default:
      return {
        boxShadow: 'none',
        background: transparentColors.blackShade3,
        borderRadius: '1rem',
        padding: '2rem',
        width: '100%',
        height: '100%',
        position: 'relative',
        minWidth: 0,
        overflow: 'hidden'
      }
  }
}
